export default "/images/menu-ico1.png?18f3820fe066d3dac925b6a1473873d5";